import React, { FC, ReactNode } from 'react';
import { useClientStatsigEnrollment } from '../../context/experiments';
import { StickyExperiment, StickyExperimentValues } from '../../types';
import './StickyExperimentWrapper.scss';

//  TODO: EB-225864
// On Failure: delete file and uses of wrapper
// On Success: remove implementations and set positionSticky for GlobalNav packages/infra/global-nav/src/modules/GlobalNav/GlobalNav.tsx
function useGetStickyExperiment() {
    const stickyExperimentVariant =
        useClientStatsigEnrollment<StickyExperimentValues>({
            name: StickyExperiment.name,
            paramName: StickyExperiment.paramName,
            defaultValue: StickyExperiment.values.control,
        }).variant;

    const isStickyHeader =
        stickyExperimentVariant === StickyExperiment.values.sticky;

    return isStickyHeader;
}

export const StickyExperimentWrapper: FC<ReactNode> = ({ children }) => {
    const isStickyHeader = useGetStickyExperiment();
    const className = isStickyHeader ? 'sticky-experiment__wrapper' : '';

    return <div className={className}>{children}</div>;
};
